import type {
  ImageComponent,
  VideoComponent,
} from '../../../../../../core/data-sources/content-components/types.js';

export const determineAssetTypeAndContent = (
  element: ImageComponent | VideoComponent,
) => {
  if (element.type === 'image' && element.caption?.value) {
    return {
      title: element.caption.value,
    };
  } else if (
    element.type === 'video' &&
    element.title?.value &&
    element.description?.value
  ) {
    return {
      title: element.title.value,
      description: element.description.value,
    };
  }

  return null;
};
